module.exports = __webpack_public_path__ + "img/0fcd82f4c332077aba7a82a09a87551c.png";